import React from 'react';

const NotificationsContext = React.createContext({ client: null });

export const NotificationsProvider = NotificationsContext.Provider;
export const NotificationsConsumer = NotificationsContext.Consumer;
